import { UserRoles } from "../../constants";

export const HeaderLinksText: any = {
    [UserRoles.SCHEDULER] : 'Scheduler',
    [UserRoles.PRACTICE_ADMIN] : 'Practice Admin',
    [UserRoles.THERAPIST] : 'Provider',
    [UserRoles.TENANT_SUPER_ADMIN] : 'Super Admin'
};